import { FiCheckCircle } from 'react-icons/fi'

export const DoneView = () => {
	return (
		<div className="flex flex-col items-center justify-center gap-4 py-8">
			<FiCheckCircle className="w-16 h-16 text-green-500" />
			<p className="text-[18px] leading-[24px] font-medium text-t-default">
				Account connected successfully!
			</p>
		</div>
	)
}

